import { SXStyleSheet } from '@/utils';

/**
 * Dialog-Huelle im Zielstil (Design-Rollout 25.10.2026): 24px Innenabstand,
 * 16px zwischen Kopf, Inhalt und Aktionen. Die Aktionsleiste traegt der
 * Aufrufer ueber `ActionArea` — fuer sie gibt es `dialogAktionenSx` in
 * `theme/bausteine.ts`, damit nicht jeder Dialog eigene Abstaende setzt.
 */
const style = SXStyleSheet.create({
  container: {
    p: 6,
    gap: 4,
  },
  iconGroup: {
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
  },
  kopf: {
    gap: 1,
  },
});

export default style;
